export default "__VITE_ASSET__CjOsfnp1__"